import { render } from "./name-field.vue?vue&type=template&id=6a25b27c"
import script from "./name-field.vue?vue&type=script&lang=js"
export * from "./name-field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__